<!--
 * @Author: cmchiu
 * @Date: 2023-05-02 10:36:22
 * @LastEditTime: 2023-05-19 12:47:50
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\views\components\downloadLs.vue
 * 
-->
<template>
    <div :id="`m${menuId}`" class="law">
        <h3 class="page-subtitle" v-text="title"></h3>
        <!-- Badge -->
        <div class="badge-wrapper">
            <ul class="badge d-flex">
                <li class="badge__item" :class="!currTag || currTag == '' ? 'badge__item--active' : ''">
                    <a class="badge__link" @click="selectTag()">
                        <p class="badge__text">全部</p>
                    </a>
                </li>
                <li
                    v-for="tag in catTagLs"
                    :key="tag.ParaValue"
                    class="badge__item"
                    :class="currTag && currTag == tag.ParaValue ? 'badge__item--active' : ''"
                >
                    <a class="badge__link" @click="selectTag(tag.ParaValue)">
                        <p class="badge__text" v-text="tag.ParaLabel"></p>
                    </a>
                </li>
            </ul>
        </div>
        <!-- Law List -->
        <ul class="law__list" v-if="fileLs && fileLs.length">
            <li v-for="file in fileLs" :key="file.sno" class="law__item w-100 d-flex">
                <span class="law__category" v-text="file.CategoryTagName"></span>
                <div class="law__content d-flex justify-content-between align-items-center">
                    <h4 class="law__subtitle" v-text="file.ItemTitle"></h4>
                    <a :href="file.ItemFiles[0].location" target="_blank" class="law__link">
                        <div class="law__download d-flex">
                            <div class="law__download-img"></div>
                            <p class="law__download-text">下載</p>
                        </div>
                    </a>
                </div>
            </li>
        </ul>
        <ul class="law__list" style="text-align: center" v-else>
            <li class="law__item w-100 d-flex" style="display: inline-block">目前暫無相關資料</li>
        </ul>
        <pagination
            :page-size="pages.pageSize"
            :total.sync="pages.totalResult"
            :currPage.sync="pages.pageCurrent"
            @page-change="pageChange"
        />
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import { getParaLs, getItemContent } from '@/api/common'
import { pagination } from '@c'

export default {
    name: 'downloadLs',

    components: { pagination },

    props: {
        title: {
            type: String,
            default: '',
            required: true,
        },

        menuId: {
            type: String,
            default: '',
            required: true,
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            catTagLs: [],
            currTag: '',
            fileLs: [],
            pages: {
                totalResult: 0, // 總筆數
                pageSize: 6, // 分頁大小
                pageCurrent: 1, // 目前頁次
            },
        }
    },

    created() {
        this.getCategoryTagLs().then(() => {
            this.getMenuItemLs()
        })
    },

    computed: {
        /* currentModel: {
            get() {
                return this.model
            },
            set(val) {
                this.$emit('update:model', val)
            },
        }, */

        currentLoading: {
            get() {
                return this.loading
            },
            set(val) {
                this.$emit('update:loading', val)
            },
        },
    },

    methods: {
        async getCategoryTagLs() {
            const vm = this
            let params = {
                group: 'p_CategoryTag',
                dlTag: vm.menuId,
            }
            await getParaLs(params)
                .then(res => {
                    // handle success
                    vm.catTagLs = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.catTagLs = []
                    console.log(err)
                })
        },

        selectTag(val) {
            this.currTag = val
            this.getMenuItemLs(1)
        },

        async getMenuItemLs(chgFilters) {
            const vm = this
            const pages = vm.pages
            vm.currentLoading = true
            if (chgFilters) pages.pageCurrent = 1 //當條件改變時, 將當前頁次改回第1頁
            let params = {
                MenuID: vm.menuId,
                CategoryTag: vm.currTag,
                PageSize: pages.pageSize,
                PageCurrent: pages.pageCurrent,
            }
            await getItemContent(params)
                .then(res => {
                    // handle success
                    vm.fileLs = []
                    XEUtils.arrayEach(res.Items, item => {
                        /* item.ItemImages = JSON.parse(item.ItemImages) */
                        item.ItemFiles = JSON.parse(item.ItemFiles)
                        vm.fileLs.push(item)
                    })
                    pages.totalResult = res.TotalResult
                    if (Math.ceil(pages.totalResult / pages.pageSize) < pages.pageCurrent) {
                        pages.pageCurrent = 1
                    }
                })
                .catch(err => {
                    // handle error
                    vm.fileLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.currentLoading = false
                })
        },

        pageChange(val) {
            this.pages.pageCurrent = val
            this.getMenuItemLs()
        },
    },
}
</script>

<style lang="scss" scoped>
.badge__link {
    cursor: pointer;
}
</style>
